import { apiWithoutAuth, apiWithAuth, type ApiResponse } from '@shared';

import { termsPaths } from './paths';

import type {
  AcceptConsentsRequest,
  LangType,
  RequiredConsentsResponse,
  TermsAcceptRequest,
  TermsAcceptResponse,
  TermsAcceptStatusResponse,
  TermsDetailResponse,
  TermsType,
} from '../types';

export const getCurrentActivatedTerms = async (termsType: TermsType = 'EULA', langType: LangType = 'KO') => {
  const { data } = await apiWithoutAuth.get<ApiResponse<TermsDetailResponse>>(termsPaths.currentActivated, {
    params: { termsType, langType },
  });
  return data.result;
};

export const acceptTerms = async (params: TermsAcceptRequest) => {
  const { data } = await apiWithAuth.post<ApiResponse<TermsAcceptResponse>>(termsPaths.acceptTerms, params);
  return data.result;
};

export const getTermsAcceptStatus = async (termsType: TermsType = 'EULA', langType: LangType = 'KO') => {
  const { data } = await apiWithAuth.get<ApiResponse<TermsAcceptStatusResponse>>(termsPaths.acceptStatus, {
    params: { termsType, langType },
  });
  return data.result;
};

/** TRAD-3759 — 필수 항목 중 «지금 활성 버전»에 동의 기록이 없는 것. 빈 배열 = 동의 화면 불필요. */
export const getRequiredMissingConsents = async () => {
  const { data } = await apiWithAuth.get<ApiResponse<RequiredConsentsResponse>>(termsPaths.requiredMissing);
  return data.result;
};

/** TRAD-3759 — 여러 동의를 한 번에. 응답 = 남은 필수 미동의 목록. 버전 불일치 409 TERMS_004 · 모르는 종류 400 TERMS_005. */
export const acceptConsents = async (params: AcceptConsentsRequest) => {
  const { data } = await apiWithAuth.post<ApiResponse<RequiredConsentsResponse>>(termsPaths.acceptBatch, params);
  return data.result;
};

/**
 * TRAD-3759 — 가입 화면(로그인 전)이 동의 행·버전을 얻는 곳. 공개(로그인 불필요). 활성 버전이 없는 종류는 서버가 뺀다.
 * 가입 요청 `consents` 에 이 버전을 그대로 싣는다(버전이 다르면 서버가 그 항목만 기록하지 않고 `unrecordedConsents` 로 알린다).
 */
export const getRequiredConsents = async () => {
  const { data } = await apiWithoutAuth.get<ApiResponse<RequiredConsentsResponse>>(termsPaths.required);
  return data.result;
};
